import Pill from "../common/Pill";
import Vision from "../../assets/vision.png"

const VisionSection = () => {
  return (
    <section className="py-10 bg-white">
      {/* Wrapper */}
      <div className="max-w-6xl mx-auto px-4">

        {/* Pill + Heading */}
        <div className="flex flex-col items-center text-center mb-12">
          <Pill text="THE FUTURE IS VOICE" backgroundColor="#FFECEC" />

          <h2 className="text-[#6A0F0F] font-bold text-3xl md:text-4xl mt-4">
            Our Vision
          </h2>

          <p className="text-gray-600 mt-2 max-w-xl">
            Making every place interactive with smart, no-code Voice AI agents.
          </p>
        </div>

        {/* Content Grid */}
        <div className="grid grid-cols-1 md:grid-cols-2 gap-8">

          {/* LEFT: Image Block */}
          <div className="flex justify-center items-center">
            <img src={Vision} alt="Vision" className="w-full object-contain rounded-2xl"  />
          </div>

          {/* RIGHT: Text Block */}
          <div className="bg-[#FAFAFA] rounded-3xl p-8 flex flex-col justify-between">
           <div>
             <p className="text-gray-700 leading-relaxed">
              We believe Voice AI will reshape how people interact with information 
              in the physical world. Our vision is simple: to become the digital
              voice for every place.
            </p>

            <p className="text-gray-700 leading-relaxed mt-4">
              From restaurants to retail, any business can deploy a smart,
              interactive voice agent using just QR codes. No technical
              skills required.
            </p>
            <br />
           </div>

            {/* BUTTON */}
            <a
              href="https://app.agoravoice.ai"
              target="_blank"
              rel="noopener noreferrer"
              className={`w-full sm:w-auto inline-block text-center
                text-base sm:text-lg md:text-xl
                bg-gradient-to-r from-[#B22222] to-[#FF4D4D]
                font-semibold border border-gray-400 text-white
                px-6 py-3 sm:px-8 sm:py-4
                rounded-full
                hover:scale-105 transition-transform`}
            >
              Try For Free
            </a>
          </div>

        </div>
      </div>
    </section>
  );
};

export default VisionSection;
